import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setInventory } from '../../store/inventory/InventoryActions';

export const useSetInventoryData = (): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setInventory());
  }, []);
};
